<div class="p-grid" *ngFor="let z of orderType.OOOrderTypeDeliveryZone; let idx = index">
	<div class="p-col-12 p-md-3 p-lg-3 p-xl-3 d-flex">
		<span class="p-float-label mt-4">
			<input
				pInputText
				#deliveryZoneNameValue
				name="deliveryZoneNameValue"
				type="text"
				[(ngModel)]="z.name"
				class="w-100"
				(ngModelChange)="changesToSaveChange.emit(true); changesToSave = true"
			/>
			<label for="deliveryZoneNameValue">Zone {{ idx + 1 }}</label>
		</span>
		<span class="mt-4">
			<p-colorPicker
				[(ngModel)]="z.fillColor"
				styleClass="me-2 ms-2"
				[disabled]="true"
				name="colorDisplay"
				(ngModelChange)="changesToSaveChange.emit(true); changesToSave = true"
			></p-colorPicker>
		</span>
	</div>
	<div class="p-col-12 p-md-3 p-lg-3 p-xl-3">
		<span class="p-float-label mt-4">
			<p-inputNumber
				#deliveryFeeValue
				[(ngModel)]="z.deliveryFee"
				id="{{ idx }}"
				mode="currency"
				currency="USD"
				locale="en-US"
				inputStyleClass="text-right"
				styleClass="w-100"
				(ngModelChange)="changesToSaveChange.emit(true); changesToSave = true"
			></p-inputNumber>
			<label for="deliveryFeeValue">Delivery Fee</label>
		</span>
	</div>
	<div class="p-col-12 p-md-3 p-lg-3 p-xl-3">
		<span class="p-float-label mt-4">
			<p-dropdown
				#feeMenuItem
				[options]="venueSvc.ooMenuItems"
				optionLabel="name"
				optionValue="menuItemKey"
				name="feeMenuItem"
				[(ngModel)]="z.menuItemKey"
				[style]="{ width: '100%' }"
				appendTo="body"
				[autoDisplayFirst]="false"
				[virtualScroll]="true"
				virtualScrollItemSize="30"
				filter="true"
				(filterBy)="app.keys(venueSvc.ooMenuItems)"
				(ngModelChange)="changesToSaveChange.emit(true); changesToSave = true"
			></p-dropdown>
			<label for="feeMenuItem">Fee Menu Item</label>
		</span>
	</div>
	<div class="p-col-12 p-md-3 p-lg-3 p-xl-3">
		<span class="d-flex mt-4">
			<button pButton pRipple class="p-button-rounded p-button-danger me-2 ms-2" label="Delete" icon="pi pi-trash" (click)="deleteZone(z)"></button>
		</span>
	</div>
</div>
<div class="p-grid">
	<div class="p-col">
		<google-map height="500px" width="100%" [zoom]="zoom" [center]="center" [options]="options" id="gMap">
			<div *ngIf="loaded && orderType.OOOrderTypeDeliveryZone">
				<div *ngFor="let p of orderType.OOOrderTypeDeliveryZone" id="{{ p.key }}">
					<map-polygon [paths]="p.points" [options]="p.polygonOptions"></map-polygon>
				</div>
			</div>

			<map-marker [position]="center" [options]="markerOptions"></map-marker>
		</google-map>
	</div>
</div>
